























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import AvatarSelectorVue from '../components/AvatarSelector.vue';


import {ClientV1 as Multiplayer} from '@javfres/escaperoom-multiplayer';
import {Debounce} from 'lodash-decorators';


import {default as toClipboard} from 'copy-to-clipboard';



import Preloader from '@/utils/preloader';
import Game from '../../engine/Game';
import App from '../../engine/App';
import gaLog from '../../utils/ga';

@Component({
    components: {
        AvatarSelectorVue
    },
})
export default class MultiplayerPage extends Vue {

    private loaded = false;

    multiplayer: Multiplayer|null = null;
    join_url: string = '';

    user_list: any[] = []; // TODO
    my_idx = -1;
    my_name = '';
    my_avatar = '';
    my_ready = false;


    error = '';

    mounted(){

        this.waitLoad();

        const join_game_id = this.$route.params.game_id; 

        if(join_game_id){
            this.join_game(join_game_id);
        } else {
            this.create_game();
        }
        

     
    }

    async waitLoad(){

        await Preloader.preloadFolder('fonts');
        await Preloader.preloadFolder('base');
        await Preloader.preloadFolder('puzzles');
        await Preloader.preloadFolder('avatars');
        this.loaded = true;

    }



    async create_game(){
        
        const multiplayer = new Multiplayer(App.SERVER);
        await multiplayer.create();
        this.multiplayer = multiplayer;

        this.after_joining();

    }

    async join_game(game_id: string){
        const multiplayer = new Multiplayer(App.SERVER);

        try {
            await multiplayer.join(game_id);
            this.multiplayer = multiplayer;
            this.after_joining();
        } catch(e){
            this.error = "Error conectado, quizá la sala está llena"
        }


    }

    after_joining(){

        this.multiplayer!.onUserData(this.update_game);

        this.join_url = window.location.href.split('/#/multiplayer')[0];
        this.join_url += '/#/multiplayer/' + this.multiplayer!.game_id;
        
        this.multiplayer!.on('chat', this.chat_recv);

        this.update_game();


    }



    update_game(){

        console.log('update game');

        if(!this.multiplayer) return;

        this.my_idx = this.multiplayer!.user_idx;

        this.user_list = this.multiplayer!.user_list.map((x,i) => {

            const data = this.multiplayer!.user_data[i];
            const name = data.name ? data.name : 'Sin nombre';
            const avatar = data.avatar ? data.avatar : '';

            return {
                name,
                avatar,
                ready: !!data.ready,
            };

        });

    }


    @Watch('my_name')
    @Debounce(1000)
    change_name(name:string) {

        if(!this.multiplayer) return;
        this.multiplayer.emitUserData({name});
        this.update_game();

    }


    @Watch('my_avatar')
    @Debounce(1000)
    change_avatar(avatar:string) {

        console.log("My avatar changed");

        if(!this.multiplayer) return;
        this.multiplayer.emitUserData({avatar});
        this.update_game();

    }

    get_avatar(avatar:string){

        if(!avatar) return '';

        console.log(avatar);

        return require(`@/assets/avatars/${avatar}_256.png`);
    }

    get ready_error(){

        if(!this.my_name){
            return "Nombre vacío";
        }

        return null;
    }

    onReady(){
        this.my_ready = true;
        this.multiplayer!.emitUserData({ready:true});
        this.update_game();
    }



    chat = '';
    chat_line = '';

    chat_send(){
        if(!this.chat_line) return;

        let name = this.my_name;
        if(!name){
            name = `Sin nombre ` + this.my_idx;
        }

        const msg = name + ": " + this.chat_line;
        this.chat_line = '';
        this.multiplayer!.emit('chat', msg);
        this.chat += msg + '\n';
    }

    chat_recv(msg:string){
        this.chat += msg + '\n';
    }



    destroyed(){

        console.log("Bye bye");
        if(this.multiplayer){
            this.multiplayer.disconnect();
        }


    }

    //beforeRouteUpdate(to) {
    //    console.log("Route update ", to);
    //
    //}
    
    @Watch('user_list', {deep:true})
    check_start(){

        let num_ready = 0;
        for(let user of this.user_list){
            if(user.ready) num_ready++;
        }

        if(num_ready === this.user_list.length){
            console.log('all ready');

            gaLog('multiplayer-start', {num_users:this.user_list.length});

            this.start_game();
        }



    }


    start_game(){
        
        const game = Game.new();
        game.join(this.multiplayer!);

        this.multiplayer!.offUserData(this.update_game);
        this.multiplayer!.off('chat', this.chat_recv);

        // To avoid to be destroyed
        this.multiplayer = null;


        this.$router.push('/game');

    }


    copy(){

        toClipboard(this.join_url, {
            debug: true,
            message: 'Pulsa #{key} para copiar',
            format: "text/plain",
            onCopy: () => { console.log('Copied') },
        });

    }


}

